import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { getNotifications } from '@/services/notifications/get-notifications';
import { NotificationListResponse } from '@/types/notification-types';
import { useOrgStore } from '@/stores/org-store';

export const NOTIFICATIONS_QUERY_KEY = 'notifications';

export const useGetNotifications = (
  options?: Partial<UseQueryOptions<NotificationListResponse, Error>>,
) => {
  const { currentOrg } = useOrgStore();
  const orgId = currentOrg?.orgid;

  return useQuery<NotificationListResponse, Error>({
    queryKey: [NOTIFICATIONS_QUERY_KEY, orgId],
    queryFn: ({ signal }) => getNotifications({ orgId: orgId!, signal }),
    refetchInterval: 10000,
    enabled: !!orgId,
    ...options,
  });
};
